import { createSlice } from '@reduxjs/toolkit';
import { responsePendingTypes } from '../../components/projectPost/PostFooter/PendingPostLabel/PendingPostLabel';

import { fetchPendingPosts } from './PendingPostsThunks';

export const initialState = {
    pending: [],
    approved: [],
    rejected: [],
    category: null,
    loading: false,
    error: false,
};

const PendingPostsSlice = createSlice({
    name: 'pendingPosts',
    initialState,
    reducers: {
        removePostFromPendingsList: (state, { payload }) => {
            state.pending = state.pending.filter(post => post.uid !== payload.rawPostData.uid);
            switch (payload.responseType) {
                case responsePendingTypes.decline:
                    state.rejected = [payload.rawPostData, ...state.rejected];
                    break;
                case responsePendingTypes.accept:
                    state.approved = [payload.rawPostData, ...state.approved];
                    break;
                default:
                    break;
            }
        },
    },
    extraReducers: builder => {
        builder
            .addCase(fetchPendingPosts.pending, state => {
                state.error = false;
                state.loading = true;
            })
            .addCase(fetchPendingPosts.fulfilled, (state, { payload }) => {
                state.pending = payload.pending;
                state.approved = payload.approved;
                state.rejected = payload.rejected;
                state.loading = false;
            })
            .addCase(fetchPendingPosts.rejected, (state, { payload }) => {
                state.error = true;
                state.loading = false;
                alert(payload);
            });
    },
});

export const PendingPostsReducer = PendingPostsSlice.reducer;
export const PendingPostsActions = {
    ...PendingPostsSlice.actions,
    fetchPendingPosts,
};
